import { Card, Col, Flex, Progress, Row } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import DeleteModal from "../../DeleteModal/DeleteModal";
import EditProjects from "../EditProjects";
import moment from "moment";

import { useTranslation } from "react-i18next";
const ProjectsGridView = ({ projects, updateParent, serviceProvider }) => {
  const { t } = useTranslation("dashboard");
  return (
    <div className="ProjectsGridView">
      <Row gutter={[16, 16]}>
        {projects?.map((project, index) => {
          return (
            <Col key={project?._id || index} xs={24} sm={12} lg={8} xl={6} xxl={4}>
              <Link to={`/user/projects/${project?._id}`}>
                <Card
                  title={project?.projectName}
                  extra={
                    serviceProvider && (
                      <div className="mb-0 mt-2 pt-0 dropdown dropdown-action text-end">
                        <Link
                          to="#"
                          className="action-icon dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="material-icons">more_vert</i>
                        </Link>
                        <div className="dropdown-menu dropdown-menu-right">
                          <EditProjects data={project} updateParent={updateParent} />
                          <DeleteModal text="Projects" onClick={() => undefined} />
                        </div>
                      </div>
                    )
                  }
                >
                  <div key={index} className="projectCard">
                    <div>
                      <small>
                        <b>1</b> {t("open tasks,")} <b>9</b> {t("tasks completed")}
                      </small>
                      <p>{project?.description}</p>
                      <div className="mt-3">
                        <h5>{t("Deadline:")}</h5>
                        <p className="text-secondary">
                          {moment(project?.endDate).format("DD/MM/YYYY")}
                        </p>
                      </div>
                      <div className="mt-3">
                        <h5>{t("Project Leader :")}</h5>
                        <img
                          width="43"
                          height="43"
                          className="rounded-circle"
                          alt=""
                          src={project?.projectLeader?.picture?.url}
                        />
                      </div>
                      <div className="mt-3">
                        <h5>{t("Team :")}</h5>
                        <Flex align="center" wrap="wrap">
                          {project?.team?.map((user, index) => {
                            return (
                              <img
                                key={index}
                                width="43"
                                height="43"
                                className="rounded-circle"
                                alt=""
                                src={user?.picture?.url}
                              />
                            );
                          })}
                        </Flex>
                      </div>
                      <Progress className="mt-3" percent={50} status="active" />
                    </div>
                  </div>
                </Card>
              </Link>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default ProjectsGridView;
